// extracted by mini-css-extract-plugin
module.exports =  {"tabs":"plpc__sipFvZ3auR0YY_qdIXCo"};